import { Logo } from '../shared/Logo';
import { Skeleton } from '../ui/Skeleton';

/**
 * Silhouette of the authenticated app shell, shown while the session is being
 * restored from the refresh cookie on a cold load. It mirrors the real sidebar
 * + top bar layout so the app appears instantly instead of flashing a blank
 * spinner — only the content area shimmers until data arrives.
 */
export function AppSkeleton() {
  return (
    <div className="flex h-dvh overflow-hidden bg-surface" aria-busy="true" aria-label="Loading workspace">
      {/* Sidebar silhouette matches the expanded merchant shell. */}
      <aside className="hidden w-64 flex-col border-r border-border bg-sidebar md:flex">
        <div className="flex h-20 shrink-0 items-center border-b border-border px-5">
          <Logo />
        </div>
        <nav className="flex-1 space-y-6 p-3">
          {[4, 3, 2].map((count, section) => (
            <div key={section} className="space-y-1">
              <Skeleton className="ml-3 mb-2 h-2.5 w-16" />
              {Array.from({ length: count }).map((_, i) => (
                <Skeleton key={i} className="h-9 w-full rounded-md" />
              ))}
            </div>
          ))}
        </nav>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        {/* Top bar silhouette matches TopBar's h-20. */}
        <div className="flex h-20 shrink-0 items-center justify-between border-b border-border bg-white px-4 md:px-8">
          <Skeleton className="h-5 w-40" />
          <Skeleton className="h-9 w-9 rounded-full" />
        </div>

        {/* Content shimmer */}
        <main className="flex-1 overflow-hidden">
          <div className="mx-auto max-w-7xl px-4 py-6 md:px-8 md:py-8">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} className="h-28 w-full rounded-xl" />
              ))}
            </div>
            <Skeleton className="mt-6 h-64 w-full rounded-xl" />
          </div>
        </main>
      </div>
    </div>
  );
}
